module.exports = __webpack_public_path__ + "static/img/sb377bb.89f9194.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/sb377bb.jpg
// module id = mCkK
// module chunks = 0